import React from "react";
import '../styles/ParagraphRight.css';

function ParagraphRight() {

    return (
        <div className="container-fluid paragraph-right-section-background my-5-5 py-5 text-white">
            <div className="container text-end">
                <h4 className="fs-2">Do waszej dyspozycji</h4>
                <hr className="divider" />
                <p className="fw-light">Do Waszej dyspozycji oddajemy salę mieszczącą do 100 osób oraz całą naszą załogę. Organizujemy różnego rodzaju przyjęcia, dancingi, zabawy karaoke. W naszej restauracji serwujemy obiady dnia, składające się z dwóch dań - zupy  i dania głównego.  Po za udostępnianiem naszej sali oferujemy również usługi cateringowe. Zapewniamy wyśmienite menu dopasowane do indywidualnych potrzeb, a także aranżację stołów, aby wszystko idealnie ze sobą współgrało i kusiło nie tylko smakiem i zapachem, ale także wspaniałym wyglądem.</p>
            </div>
        </div>
    )


}

export default ParagraphRight;